<template>
  <div class="row justify-center pt-90 lg:pt-50 mt-4">
    <div class="col-auto">
      <div class="pagination -buttons">
        <button class="pagination__button -prev rotate-svg" :disabled="currentPage === 1"
          @click="changePage(currentPage - 1)" aria-label="Previous Page">
          <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="m15 19-7-7 7-7" />
          </svg>
        </button>

        <div class="pagination__count">
          <a v-for="page in visiblePages" :key="page" :href="'#page-' + page"
            :class="{ '-count-is-active': page === currentPage }" @click.prevent="changePage(page)">
            {{ page }}
          </a>
          <span v-if="lastPage > maxVisiblePages && currentPage + 2 < lastPage">...</span>
          <a v-if="lastPage > maxVisiblePages && currentPage + 2 < lastPage" :href="'#page-' + lastPage"
            @click.prevent="changePage(lastPage)">
            {{ lastPage }}
          </a>
        </div>

        <button class="pagination__button -next rotate-svg" :disabled="currentPage === lastPage"
          @click="changePage(currentPage + 1)" aria-label="Next Page">
          <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="m9 5 7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationComponent",
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    lastPage: {
      type: Number,
      required: true,
    },
    maxVisiblePages: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    visiblePages() {
      const half = Math.floor(this.maxVisiblePages / 2);
      let start = Math.max(this.currentPage - half, 1);
      let end = Math.min(start + this.maxVisiblePages - 1, this.lastPage);

      if (end === this.lastPage) {
        start = Math.max(this.lastPage - this.maxVisiblePages + 1, 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.lastPage) return;
      this.$emit("update:currentPage", page);
    },
  },
};
</script>

<style scoped>
/* Add any specific styles for your pagination component here */
</style>